/**
 * rc-dropdown placement config with the shift clamp switched on.
 *
 * rc-dropdown's own `bottomLeft` carries `overflow: { adjustX: 1, adjustY: 1 }`,
 * which flips the popup's anchor from the trigger's left edge to its right when
 * the menu would overrun the viewport. That flip has no lower bound: in
 * @rc-component/trigger's `useAlign` the clamp that pulls a popup back inside
 * the visible area is gated on `typeof shiftX === 'number'`, and rc-dropdown
 * never sets one. So on a narrow screen a menu whose trigger sits near the left
 * of the row flips and then hangs off the LEFT edge, partly unreachable - and
 * widening or narrowing the menu can't fix it, because adjustment only ever
 * repositions a popup, never resizes one.
 *
 * `shiftX: true` (which `useAlign` reads as 0) re-enables that clamp: the menu
 * stays anchored to its trigger but gets pushed back on screen instead of
 * running off it. Everything else matches rc-dropdown's own defaults, so
 * desktop placement is unchanged.
 *
 * Only `bottomLeft` is defined - it is rc-dropdown's default placement and the
 * only one these menus use. A consumer passing an explicit `placement` needs to
 * add the matching entry here.
 */
const SHIFT_CLAMPED_PLACEMENTS = {
  bottomLeft: {
    points: ['tl', 'bl'],
    offset: [0, 4],
    targetOffset: [0, 0],
    overflow: {
      adjustX: 1,
      adjustY: 1,
      shiftX: true,
      shiftY: true,
    },
  },
};

export default SHIFT_CLAMPED_PLACEMENTS;
